export const CONSTANTS__environment_client = {
  VITE_APP_ENVIRONMENT: '',
  //
  VITE_APP_BUILD_TIME: '',
  VITE_APP_BUILD_TIMESTAMP_NUMBER: 0,

  /*
   * DEVELOPMENT
   */

  VITE_DEVELOPMENT_REACT_DEV_TOOLS_ENABLED_BOOLEAN: false,
  VITE_DEVELOPMENT_LOG_SIZE_ENABLED_BOOLEAN: false,

  VITE_SERVICE_ULTIMATEDIFFUSION_HTTP_URL_BASE: '',
  VITE_SERVICE_ULTIMATEDIFFUSION_SOCKET_CONNECTION_TIMEOUT_NUMBER: -1,
  VITE_SERVICE_ULTIMATEDIFFUSION_SOCKET_RESPONSE_TIMEOUT_NUMBER: -1,
  VITE_SERVICE_ULTIMATEDIFFUSION_SOCKET_URL: '',

  VITE_AUTH_AUTOLOGIN_BOOLEAN: false,
  VITE_AUTH_TEST_USER_EMAIL: '',
  VITE_AUTH_TEST_USER_PASSWORD: '',

  /*
   * SERVICES
   */

  //new relic
  VITE_SERVICE_NEW_RELIC_ENABLED_BOOLEAN: false,
  VITE_SERVICE_NEW_RELIC_LICENSE_KEY: '',
};
